import { c as _c } from "react/compiler-runtime";
import { alpha } from '@classify/react-core-components/styles';
import { styled } from '@classify/react-core-components/styles';
import Paper from '@mui/material/Paper';
import ListAlt from '@mui/icons-material/ListAlt';
import { translate } from '@openclassrooms/translations';
const WhiteBackground = styled('div')(({
  theme: {
    palette,
    breakpoints,
    zIndex
  }
}) => ({
  background: palette.background.paper,
  borderRadius: '32px 0px 0px 32px',
  zIndex: zIndex?.fab ?? 1050,
  [breakpoints.up('sm')]: {
    borderRadius: '0px 32px 32px 0px'
  }
}));
const Wrapper = styled(Paper, {
  shouldForwardProp: prop => prop !== 'backgroundColor'
})<{
  backgroundColor: string;
}>(({
  theme: {
    spacing,
    palette,
    breakpoints
  },
  backgroundColor
}) => ({
  backgroundColor,
  padding: 'initial',
  border: 'initial',
  borderRadius: '32px 0 0 32px',
  boxShadow: 'none',
  '& > div': {
    display: 'flex',
    alignItems: 'center',
    padding: spacing(1.5, 2),
    cursor: 'pointer',
    borderRadius: '32px 0 0 32px'
  },
  [breakpoints.up('sm')]: {
    borderRadius: '0 32px 32px 0',
    borderLeft: `1px solid ${palette.divider}`,
    '& > div': {
      borderRadius: '0 32px 32px 0'
    }
  }
}));
export interface TocTogglerButtonProps {
  categoryColor: string;
  onClick: () => void;
}
const TocTogglerButton = t0 => {
  const $ = _c(9);
  const {
    onClick,
    categoryColor
  } = t0;
  let t1;
  if ($[0] !== categoryColor) {
    t1 = alpha(categoryColor, 0.08);
    $[0] = categoryColor;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const lighterCategoryColor = t1;
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = translate("video_conferencing.chat.title.label");
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const t3 = categoryColor || "primary.main";
  let t4;
  if ($[3] !== t3) {
    t4 = <div tabIndex={-1}><ListAlt sx={{
        color: t3
      }} /></div>;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== lighterCategoryColor || $[6] !== onClick || $[7] !== t4) {
    t5 = <WhiteBackground><Wrapper backgroundColor={lighterCategoryColor} aria-label={t2} component="button" tabIndex={0} onClick={onClick}>{t4}</Wrapper></WhiteBackground>;
    $[5] = lighterCategoryColor;
    $[6] = onClick;
    $[7] = t4;
    $[8] = t5;
  } else {
    t5 = $[8];
  }
  return t5;
};
export default TocTogglerButton;